import React from 'react';
import './Culturecarte.css';
import culture1 from '../../Images/Culture/culture1.jpg'
import culture2 from '../../Images/Culture/culture2.jpg'
import culture3 from '../../Images/Culture/culture3.jpg'
import culture4 from '../../Images/Culture/culture4.jpg'
import culture5 from '../../Images/Culture/culture5.jpg'
import culture6 from '../../Images/Culture/culture6.jpg'
import culture7 from '../../Images/Culture/culture7.jpg'
import culture8 from '../../Images/Culture/culture8.jpg'
import culture9 from '../../Images/Culture/culture9.jpg'
import culture10 from '../../Images/Culture/culture10.jpg'
import culture11 from '../../Images/Culture/culture11.jpg'
import culture12 from '../../Images/Culture/culture12.jpg'
import culture13 from '../../Images/Culture/culture13.jpg'
import culture14 from '../../Images/Culture/culture14.jpg'
import culture15 from '../../Images/Culture/culture15.jpg'



const Culturecarte = () => {
    return (
        <div className="container-Culturecarte2">
            <div className='containerCulturecarte'>
                <div className='barreCulturecarte24'>
                    <div className='traitCulturecarte24s'></div>
                    <div className='traitCulture24s'></div>
                   
                </div>
            </div>

            <div className="cards1-containerCulture">
                <div className="card30">

                    <img src={culture1} alt="" />
                </div>

                <div className="card24">
                    <img src={culture2} alt="" />
                </div>

                <div className="card24">
                    <img src={culture3} alt="" />
                </div>

                <div className="card24">
                    <img src={culture4} alt="" />
                </div>

                <div className="card24">
                    <img src={culture5} alt="" />
                </div>

                <div className="card24">
                    <img src={culture6} alt="" />
                </div>

                <div className="card24">
                    <img src={culture7} alt="" />
                </div>
                 
                <div className="card24">
                    <img src={culture8} alt="" />
                </div>

                <div className="card24">
                    <img src={culture9} alt="" />
                </div>
                
                <div className="card24">
                    <img src={culture10} alt="" />
                </div>
                 
                <div className="card24">
                    <img src={culture11} alt="" />
                </div>
                  
                <div className="card24">
                    <img src={culture12} alt="" />
                </div>
                   
                <div className="card24">
                    <img src={culture13} alt="" />
                </div>
                     
                <div className="card24">
                    <img src={culture14} alt="" />
                </div>  

                <div className="card24">
                    <img src={culture15} alt="" />
                </div>


            </div>
        </div>
        

    );
};

export default Culturecarte;